var map = {
  "./Idea-Poll-Details-Image.svg": "38425",
  "./NPS-import-review.svg": "18575",
  "./agent-mode-cta.svg": "27327",
  "./ai-idea-generation.svg": "51526",
  "./ai/ai-highlight-icon.svg": "97645",
  "./ai/ai-idea-generation.svg": "53433",
  "./ai/ai-template-action.svg": "67220",
  "./ai/ai-template-map.svg": "12056",
  "./ai/ai-template-pencil.svg": "16825",
  "./ai/ai-templates-background.svg": "32397",
  "./ai/ai-templates-side.svg": "48792",
  "./ai/ai-topic-icon.svg": "62109",
  "./ai/prompt-template-action.svg": "87804",
  "./ai/prompt-template-map.svg": "96272",
  "./ai/prompt-template-pencil.svg": "87713",
  "./ai/prompt-templates-side.svg": "25168",
  "./airtable.svg": "23067",
  "./comments-empty-state.svg": "48197",
  "./confirmation.svg": "23132",
  "./context-onboarding-1.png": "96787",
  "./context-onboarding-2.png": "51032",
  "./csv-import.svg": "19825",
  "./drag_to_reposition.svg": "64880",
  "./email-setup-modal.svg": "64705",
  "./email-visual.svg": "91286",
  "./empty-state-feedback.svg": "98582",
  "./empty-state-portals.png": "63247",
  "./empty-state-summary-with-ai.svg": "20177",
  "./empty-state-summary-without-ai.svg": "10597",
  "./explore-init-sync.png": "14950",
  "./failed-uploads.svg": "57469",
  "./favorite-views-empty.svg": "82302",
  "./feedback-mini-icon.svg": "99936",
  "./feedback-status-update.svg": "86141",
  "./feedback-view-mid-fi.svg": "67405",
  "./feedback/type-feedback-icon.svg": "8259",
  "./funnel.svg": "75739",
  "./google-sheets.svg": "88567",
  "./horizon-search-error.svg": "94968",
  "./hover-card-empty-state.svg": "66882",
  "./idea-list-empty-state.png": "62496",
  "./idea-list-filters-empty-state.svg": "99213",
  "./idea-mini-icon.svg": "55816",
  "./idea-poll-filter-illustration.svg": "59614",
  "./idea-poll-illustration.svg": "77967",
  "./idea-status-update.svg": "17941",
  "./idea-test-multi-page-layout.svg": "77428",
  "./idea-test-single-page-layout.svg": "89999",
  "./ideas-jira-integration.svg": "79547",
  "./import-csv.svg": "62791",
  "./import-guide-polls.svg": "32594",
  "./import-nps.svg": "59089",
  "./import-salesforce.svg": "49696",
  "./import-to-listen.svg": "17350",
  "./in-app-visual.svg": "80857",
  "./insights-page-empty.svg": "75216",
  "./insights-screenshot.svg": "37305",
  "./link-idea-empty.svg": "8377",
  "./loading-csv-items.svg": "11865",
  "./logo-csv-review-step.svg": "42889",
  "./no-guide-selected.svg": "74161",
  "./no-nps-selected.svg": "5290",
  "./no-portal-sharing.svg": "79102",
  "./no-portals-found.svg": "58243",
  "./no-search-results.svg": "10534",
  "./no-selected-idea.svg": "25056",
  "./no-templates-filtered-out.svg": "69419",
  "./onboarding-shield.svg": "76386",
  "./pendo-sparkle-upload.gif": "81276",
  "./pendo-sparkles.svg": "23237",
  "./portal-create.svg": "26074",
  "./promote-idea.svg": "30575",
  "./quick-start-header.svg": "5043",
  "./roi-page-arrows.svg": "10788",
  "./roi-page-empty-bg.png": "26036",
  "./save-feedback-view-modal-side.svg": "6098",
  "./source-icon/API-icon-withname.svg": "30121",
  "./source-icon/API-icon.svg": "23575",
  "./source-icon/CSV-icon-withname.svg": "1373",
  "./source-icon/CSV-icon.svg": "4659",
  "./source-icon/Gong-icon-withname.svg": "85403",
  "./source-icon/Gong-icon.svg": "45684",
  "./source-icon/Hubspot-icon.svg": "43931",
  "./source-icon/Intercom-icon.svg": "71458",
  "./source-icon/NPS-icon-withname.svg": "80188",
  "./source-icon/NPS-icon.svg": "29888",
  "./source-icon/Salesforce-icon-withname.svg": "82189",
  "./source-icon/Salesforce-icon.svg": "90810",
  "./source-icon/SlackMessages-icon-withname.svg": "95293",
  "./source-icon/SlackMessages-icon.svg": "28179",
  "./source-icon/Teams-icon-withname.svg": "7051",
  "./source-icon/Teams-icon.svg": "17477",
  "./source-icon/ZendeskTickets-icon-withname.svg": "30188",
  "./source-icon/ZendeskTickets-icon.svg": "91376",
  "./source-icon/Zoom-icon-withname.svg": "35310",
  "./source-icon/Zoom-icon.svg": "21078",
  "./source-icon/feedbackV1-icon-withname.svg": "86118",
  "./source-icon/feedbackV1-icon.svg": "935",
  "./source-icon/g2-icon.svg": "23304",
  "./source-icon/guide-icon-withname.svg": "87857",
  "./source-icon/guide-icon.svg": "96991",
  "./source-icon/internalForm-icon-withname.svg": "87606",
  "./source-icon/internalForm-icon.svg": "40606",
  "./source-icon/pendo-icon.svg": "91645",
  "./source-icon/portal-icon-withname.svg": "38761",
  "./source-icon/portal-icon.svg": "15287",
  "./source-icon/source-pendo-icon.svg": "99011",
  "./source-icon/surveys-icon-withname.svg": "4616",
  "./source-icon/surveys-icon.svg": "36788",
  "./source-icon/unknown-icon.svg": "61981",
  "./sources-background.png": "12247",
  "./states/loading-chart.svg": "76991",
  "./subscriber-list.svg": "12906",
  "./successful-uploads.svg": "75748",
  "./template.svg": "48385",
  "./tip-background.svg": "69055",
  "./voc-feedback-form-background.svg": "18215",
  "./voc-portal-rc-listen.svg": "70236",
  "./voc-portal-rc-preview.svg": "25663",
  "./workarounds.svg": "18786"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 61658;
